import { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import instanceOfAxios from '../../../../../app/axios/axios';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import BookingDetails from '../../../booking/bookingDetails/bookingDetails';
import { useStore } from 'react-redux';
import Spinner from '../../../../spinner/Spinner';
import { useEffect } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';

export default function Accountingtourism(props) {
    const [pending, setPending] = useState(true);
    const [data, setData] = useState([]);
    const [params, setParams] = useState({ on_year: false });
    const role = useStore().getState().header.role;
    const beginYear = new Date();
    const endYear = new Date();

    beginYear.setMonth(0);
    beginYear.setDate(1);

    endYear.setMonth(11);
    endYear.setDate(31);

    useEffect(() => {
        if (pending) {
            let query = new URLSearchParams(params).toString();
            instanceOfAxios.get('/admin/getCountingValues?' + query)
                .then(res => {
                    setData(Object.assign([], res.data.data));
                    setPending(false);
                })
                .catch(err => {
                    setPending(false);
                })
        }
    }, [pending])

    useEffect(() => {
        if(props.isActive){
            setPending(true);
            setData([]);
        }
    }, [props.isActive])

    function createCustomExportCSVButton(onClick) {
        return (
                <Button variant='secondary' onClick={onClick}>Exporter au format CSV</Button>
        );
    }

    function priceFormatter(cell, row) {
        return parseFloat(cell).toFixed(2).toString().replace('.', ',') + ' €';
    }

    function dateFormatter(cell, row) {
        let date = new Date(cell.replace(/\s/, 'T'));
        var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('fr-CA', options);
    }

    function BookingDetailFormatter(cell, row) {
        return (
            <BookingDetails booking={row} role={role} />
        );
    }

    function handleChange(event) {
        params[event.target.name] = event.target.value;
        setParams(params);
    }

    function handleCheck(event) {
        params[event.target.name] = event.target.checked;
        setParams(params);
    }

    const options = {
        exportCSVBtn: createCustomExportCSVButton
    };

    return (
        <>
            <Row className='text-center mb-3 d-flex justify-content-center'>
                <Col xs={12} md={4}>
                    Du
                    <Form.Control type="date" name="begin_period" defaultValue={beginYear.toISOString().slice(0, 10)} onChange={(e) => handleChange(e)} />
                </Col>
                <Col xs={12} md={4}>
                    Au
                    <Form.Control type="date" name="end_period" defaultValue={endYear.toISOString().slice(0, 10)} onChange={(e) => handleChange(e)} />
                </Col>
                <Col xs={12} md={5}>
                    Réference de logement
                    <Form.Control type="text" name="apart_ref" placeholder="5***" onChange={(e) => handleChange(e)} />
                </Col>
                <Col xs={12} className='d-flex align-items-end justify-content-center'>
                    <Form.Group className='mb-0'>
                        <Form.Check className='d-flex align-items-center mb-0' type="checkbox" name="on_year" label="au bon de commande" onChange={(e) => handleCheck(e)} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12} className='text-center' style={{ marginBottom: "15px" }}>
                    {
                        pending ?
                            <Spinner />
                            :
                            <Button variant='secondary' className='whiteSVG' onClick={() => setPending(true)}>Rechercher <AiOutlineSearch/></Button>
                    }
                </Col>
            </Row>
            <BootstrapTable data={data} options={options} hover pagination exportCSV csvFileName='CA-taxe-séjour-class-appart.csv'>
                <TableHeaderColumn dataField='apartment_id' dataFormat={BookingDetailFormatter} width='90'>Détails</TableHeaderColumn>
                <TableHeaderColumn isKey dataField='created_at' dataFormat={dateFormatter} csvHeader='Date de création' csvFormat={dateFormatter} dataSort={true} width='180'>Réservé</TableHeaderColumn>
                <TableHeaderColumn dataField='begin_date_hour' dataFormat={dateFormatter} csvHeader='Date de début' csvFormat={dateFormatter} dataSort={true} width='180'>Début</TableHeaderColumn>
                <TableHeaderColumn dataField='end_date_hour' dataFormat={dateFormatter} csvHeader='Date de fin' csvFormat={dateFormatter} dataSort={true} width='180'>Fin</TableHeaderColumn>
                <TableHeaderColumn dataField='reference' dataSort={true} csvHeader='Référence de réservation' width='100'>Ref</TableHeaderColumn>
                <TableHeaderColumn dataField='type' dataSort={true} csvHeader='Type logement' width='70'>Type</TableHeaderColumn>
                <TableHeaderColumn dataField='duration' dataSort={true} csvHeader='Durée' width='80'>Durée</TableHeaderColumn>
                <TableHeaderColumn dataField='nb_person' dataSort={true} csvHeader='Nb personnes' width='80'>PERS</TableHeaderColumn>
                <TableHeaderColumn dataField='nb_adult' dataSort={true} csvHeader='Nb adultes' width='100'>Adultes</TableHeaderColumn>
                <TableHeaderColumn dataField='rate' dataSort={true} csvHeader='Tarif' width='120' csvFormat={priceFormatter} dataFormat={priceFormatter}>Tarif</TableHeaderColumn>
                <TableHeaderColumn dataField='tourism' dataSort={true} csvHeader='taxe séjour' width='120' csvFormat={priceFormatter} dataFormat={priceFormatter}>Total taxe</TableHeaderColumn>
                <TableHeaderColumn dataField='3_quarter_tourism' dataSort={true} csvHeader='taxe séjour 1er trimestre' width='300' csvFormat={priceFormatter} dataFormat={priceFormatter}>Premier trimestre taxe séjour</TableHeaderColumn>
                <TableHeaderColumn dataField='6_quarter_tourism' dataSort={true} csvHeader='taxe séjour 2ème trimestre' width='300' csvFormat={priceFormatter} dataFormat={priceFormatter}>Deuxième trimestre taxe séjour</TableHeaderColumn>
                <TableHeaderColumn dataField='9_quarter_tourism' dataSort={true} csvHeader='taxe séjour 3ème trimestre' width='300' csvFormat={priceFormatter} dataFormat={priceFormatter}>Troisième trimestre taxe séjour</TableHeaderColumn>
                <TableHeaderColumn dataField='12_quarter_tourism' dataSort={true} csvHeader='taxe séjour 4ème trimestre' width='300' csvFormat={priceFormatter} dataFormat={priceFormatter}>Quatrième trimestre taxe séjour</TableHeaderColumn>
            </BootstrapTable>
            <Row>
                <Col xs={12} md={6} className='text-center d-flex flex-column'>
                    <small>*PC : Prix coutant</small>
                    <small>*RP : Remboursement propriétaire</small>
                    <small>*FP : Facture prestataire</small>
                </Col>
                <Col xs={12} md={6} className='text-center d-flex flex-column'>
                    <small>*CA : Commission achat</small>
                    <small>*CS : Commission service</small>
                </Col>
            </Row>
        </>
    )
}